import "../libs/vide/jquery.vide.min";
import {PewComponent} from "./pew-component";

export class VideoBgComponent extends PewComponent {

    init(){
      if(window.innerWidth>=768) {
        this.element.vide(this.element.data('video'));
      }
    }

}

window.pew.addRegistryEntry({key: 'videobg', domSelector: '[data-video]', classDef: VideoBgComponent});
